import LoadingSpinner from 'common/Components/LoadingSpinner/LoadingSpinner';
import useIframeSiteSelection from 'ui/components/SitePicker/useIframeSiteSelection';

const SiteLoadingPage = () => {
  useIframeSiteSelection();
  return <LoadingSpinner blockUI />;
};

export default SiteLoadingPage;
